import { http } from '@/plugins/http/index';

import type { Course, CourseDetail } from './vuex.d';
import type { CourseType, Filters } from '@/views/Enrollments/List/index.d';

export default {
  async getCourses(page: number, sort: string, filters: Filters, forceFresh = false): Promise<Course[]> {
    return http.fetch<Course[]>('courses/public', { page, sort, filter: filters }, undefined, undefined, forceFresh);
  },

  async getCourse(courseId: number): Promise<CourseDetail> {
    return http.fetch<CourseDetail>(`courses/public/${courseId}`);
  },

  async enrollToCourse(courseId: number): Promise<CourseDetail> {
    return http.post<undefined, CourseDetail>(`courses/public/${courseId}/enroll`);
  },

  async getCourseTypes(): Promise<CourseType[]> {
    return http.fetch<CourseType[]>('course-types', { filters: true });
  },
};
